// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2yoL4","title":"Header_title__3coCa","side":"Header_side__2FWjb"};